import { Component } from '@angular/core';

interface ComparisonItem {
  text: string;
}

@Component({
  selector: 'app-comparison-section-redesign',
  templateUrl: './comparison-section-redesign.component.html',
  styleUrls: ['./comparison-section-redesign.component.scss']
})
export class ComparisonSectionRedesignComponent {

  altheaFeatures: ComparisonItem[] = [
    { text: 'Predictive' },
    { text: 'Automated' },
    { text: 'Unified platform' },
    { text: 'Enterprise-ready' }
  ];

  traditionalFeatures: ComparisonItem[] = [
    { text: 'Reactive' },
    { text: 'Manual' },
    { text: 'Fragmented' },
    { text: 'Hard to scale' }
  ];

  trackByText(index: number, item: ComparisonItem): string {
    return item.text;
  }

}